import React from 'react';

import Section from '../../containers/Section';
import firdaus from '../../assets/firdaus.png';
import windi from '../../assets/windi.png';
import joko from '../../assets/joko.jpg';
import ikhwan from '../../assets/ikhwan.png';
import rizky from '../../assets/rizky.png';

import { useInView } from 'react-intersection-observer';

const contentData = [
  { name: 'Firdaus', image: firdaus, role: 'Product Designer', roleDesc: 'UI/UX Designer and Product Manager for cotechca.com.' },
  { name: 'Windi Yulianto', image: windi, role: 'UX & Web Developer', roleDesc: 'UX Research and develop website of front end.' },
  { name: 'Joko Purwanto', image: joko, role: 'Fullstack Developer', roleDesc: 'Develop desktop and mobile sites using ReactJS.' },
  { name: 'Ikhwan Syaifani', image: ikhwan, role: 'Mobile Developer', roleDesc: 'Fullstack developer for mobile apps using Flutter.' },
  { name: 'Rizky Hidayat', image: rizky, role: 'Digital Marketing', roleDesc: 'Digital Marketing & Graphic Designer who make the content in webs and social media apps.' }
]

const Team = () => {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  return (
    <Section innerClass="pb-10 pt-24 max-w-[90%] xl:max-w-[80%] lg:pt-32 2xl:my-40" outerClass="bg-white overflow-y-hidden" ref={ref}>
      <div className="uppercase text-xl text-center tracking-widest text-slate-700 lg:text-2xl 2xl:text-3xl">Team Member</div>
      <ul className={`w-full flex pt-16 flex-wrap transition-transform duration-1000 ${inView ? 'translate-y-0' : 'translate-y-full'} xl:flex-nowrap`}>
        {contentData.map((content, index) => (
          <li key={content.name} className="basis-1/2 p-1 mt-2 max-w-full md:p-5 xl:p-2">
            {/* <div className={`flex items-center flex-col px-2 py-10 shadow-md min-h-full 2xl:max-w-[80%] ${index % 2 !== 0 ? '2xl:mr-auto' : '2xl:ml-auto'}`}> */}
            <div className={`flex items-center flex-col px-2 py-10 shadow-md min-h-full`}>
              <img src={content.image} alt="" className="w-32 h-32 rounded-full xl:w-36 xl:h-36 xl:mb-2" />
              <div className="uppercase text-center text-base tracking-widest text-slate-600 mt-2 md:text-lg md:font-medium lg:text-xl xl:text-base xl:mt-4 2xl:text-2xl">{content.name}</div>
              <p className="text-sm font-light text-center tracking-wider text-slate-400 md:text-base 2xl:text-xl">{content.role}</p>
              <p className="text-sm text-center mt-2 tracking-wider text-slate-400 md:text-slate-600 lg:mt-4 lg:text-base 2xl:text-lg">{content.roleDesc}</p>
            </div>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default Team;
